export default __webpack_public_path__ + "static/media/satosh-babu-new.44c2aaed.png";